import { GridViewType } from 'app/shared/components/grid/grid-config';
import { InvoiceModel } from '../../customer.model';
import { DatePipe, CurrencyPipe } from '@angular/common';
import { CapitalizePipe } from '../../../../shared/pipes/capitalize.pipe';

export const CustomerInvoicesConfig: GridViewType<InvoiceModel> = {
  columns: [
    {
      label: 'Invoice #',
      code: 'invoiceNumber',
      filterType: 'select',
      class: 'column-140'
    },
    {
      label: 'Invoice Date',
      code: 'invoiceDate',
      pipes: [
        { pipe: DatePipe, args: 'short' }
      ],
      class: 'column-140'
    },
    {
      label: 'Amount',
      code: 'amount',
      pipes: [
        { pipe: CurrencyPipe }
      ],
      class: 'column-120'
    },
    {
      label: 'Due Date',
      code: 'dueDate',
      pipes: [
        { pipe: DatePipe, args: 'short' }
      ],
      class: 'column-140'
    },
    {
      label: 'Status',
      code: 'status',
      filterType: 'select',
      pipes: [
        { pipe: CapitalizePipe }
      ],
      template: 'invoiceStatusTemplate',
      class: 'column-120'
    },
    {
      label: 'Actions',
      code: 'actions',
      template: 'invoiceActionsTemplate',
      class: 'column-actions'
    }
  ]
};

